(function($) {
	'use strict';
	$(document).ready(function(){

		$('#burgerMenuIcon').click(function(){
			$(this).toggleClass('--open');
			$('#header').toggleClass('--showMenu');
		});

	// Slider 'Slick'
		
		$('#testimonies_slider').slick({
			autoplay: true,
			autoplaySpeed: 6000,
			prevArrow: $('.testimonies_prev'),
      nextArrow: $('.testimonies_next'),
		});






	// MAP PROJETCS

		let $map = document.querySelector('#map');
		let customIcon = L.icon({
			iconUrl: '/wp-content/themes/vupar/img/marker-icon.svg',
			iconSize:     [25, 41],
			iconAnchor:   [12, 41],
			popupAnchor:  [50, 51]
		});
		let customIconActive = L.icon({
			iconUrl: '/wp-content/themes/vupar/img/marker-icon-active.svg',
			iconSize:     [25, 41],
			iconAnchor:   [12, 41],
			popupAnchor:  [0, 70] 
		});
	
		class LeafletMap {
			constructor() {
				this.map = null
				this.bounds = []
			}
			load(element) {
				this.map = L.map(element)
				L.tileLayer('//{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
					attribution: 'donn&eacute;es &copy; <a href="//osm.org/copyright">OpenStreetMap</a>/ODbL - Tiles courtesy of <a href="https://hot.openstreetmap.org/">Humanitarian OpenStreetMap Team</a>',
					minZoom: 1,
					maxZoom: 18
				}).addTo(this.map)
				this.map.scrollWheelZoom.disable();
			}
			addMarker(lat, lng, link, text) {
				let point = [lat, lng]
				this.bounds.push(point)
				return new LeafletMarker(point, this.map, link, text)
			}
			center() {
				this.map.fitBounds(this.bounds)
			}
		} 

		class LeafletMarker {
			constructor(point, map, link, text) {
				this.marker = L.marker(point, {icon: customIcon}).addTo(map).bindPopup('<a href="' + link + '" class="e-popup"><p>' + text + '<svg class="svg" aria-label="icon"><use xlink:href="#svg-arrow-small"></use></svg></p></a>').openPopup();
			}
			setActive() {
				this.marker.setIcon(customIconActive)
			}
			unsetActive() {
				this.marker.setIcon(customIcon)
			}
			addEventListener(event, cb) {
				this.marker.addEventListener(event, cb)
			}
		}

		const initMap = function() {
			let map = new LeafletMap()
			map.load($map)
			Array.from(document.querySelectorAll('.js-marker')).forEach((item) => {
				let link = item.getAttribute('href')
				let title = item.querySelector('.js-marker-title').textContent
				let structure = item.querySelector('.js-marker-structure').textContent
				let text = '<span>' + title + '</span> - ' + structure
				console.log(text);
				item.querySelectorAll('.js-marker-item').forEach((element) => {
					let marker = map.addMarker(element.dataset.lat, element.dataset.lng, link, text)
					item.addEventListener('mouseover', function() {
						marker.setActive()
					})
					item.addEventListener('mouseleave', function() {
						marker.unsetActive()
					})
					marker.addEventListener('mouseover', function() {
						marker.setActive()
					})
					marker.addEventListener('mouseout', function() {
						marker.unsetActive()
					})
				})
				
			})
			map.center()
		}

		if($map !== null) {
			initMap()
		}

	// END MAP PROJECTS


	// SIMPLE MAP

		let $map_simple = document.querySelector('#map_simple');
		
		class LeafletMapSimple {
			constructor() {
				this.map = null
				this.bounds = []
			}

			load(element) {
				this.map = L.map(element)
				L.tileLayer('//{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
					attribution: 'donn&eacute;es &copy; <a href="//osm.org/copyright">OpenStreetMap</a>/ODbL - Tiles courtesy of <a href="https://hot.openstreetmap.org/">Humanitarian OpenStreetMap Team</a>',
					minZoom: 1,
					maxZoom: 18
				}).addTo(this.map)
			}

			addMarker(lat, lng) {
				let point = [lat, lng]
				this.bounds.push(point)
				return new LeafletMarkerSimple(point, this.map)
			}

			center() {
				this.map.fitBounds(this.bounds)
			}
		}

		class LeafletMarkerSimple {
			constructor(point, map) {
				this.marker = L.marker(point, {icon: customIcon}).addTo(map)
			}
		}

		const initMapSimple = function() {
			let map = new LeafletMapSimple()
			map.load($map_simple)
			Array.from(document.querySelectorAll('.js-simple-marker')).forEach((item) => {
				let marker = map.addMarker(item.dataset.lat, item.dataset.lng)
			})
			map.center()
		}

		if($map_simple !== null) {
			initMapSimple()
		}

	// END SIMPLE MAP

	});




	// FILTERS PROJETCS

	$(document).on('change', '[name=filter]', function(e){
		var value = e.target.value;
		var category = (value === 'in_progress' ? '' : '?category=' + value);
		var url = document.location.protocol + '//' + document.location.hostname + ':' + document.location.port + document.location.pathname + category;
		document.location.href = url;
	});

	// END FILTERS PROJECTS



})(jQuery);
